/**
 * Removes whitespace from both sides of a string.
 * Also removes extra white spaces in between words.
 * @example
 *
 * ```jsx
 *
 * let test = '   this    is a  test   '
 * trimExtraSpacesStringUtil(test) => 'this is a test'
 *
 * ```
 *
 * @param  {string} str
 * @returns {string}
 */
export default function trimExtraSpacesStringUtil (str) {
  return str.trim().replace(/\s+/g, ' ')
}
